module.exports = __webpack_public_path__ + "img/cert25.231bf1a1.png";